// src/components/Modal.tsx
import React, { useEffect, useRef } from 'react';
import ReactDOM from 'react-dom';

interface ModalProps {
  isOpen: boolean;
  onClose: () => void;
  children: React.ReactNode;
}

const Modal: React.FC<ModalProps> = ({ isOpen, onClose, children }) => {
  const modalRoot = useRef<HTMLElement | null>(null);
  const modalEl = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    // Create or get modal root element
    let root = document.getElementById('modal-root');
    if (!root) {
      root = document.createElement('div');
      root.setAttribute('id', 'modal-root');
      document.body.appendChild(root);
    }
    modalRoot.current = root;

    // Create modal element
    const el = document.createElement('div');
    modalEl.current = el;

    // Add to DOM
    if (modalRoot.current && modalEl.current) {
      modalRoot.current.appendChild(modalEl.current);
    }

    // Cleanup
    return () => {
      if (modalRoot.current && modalEl.current) {
        modalRoot.current.removeChild(modalEl.current);
      }
    };
  }, []);

  if (!isOpen || !modalEl.current) return null;

  return ReactDOM.createPortal(
    <div 
      className="fixed inset-0 bg-black/70 backdrop-blur-sm flex items-center justify-center z-[9999] p-4"
      onClick={onClose}
    >
      <div 
        className="bg-gray-900 border border-gray-700 p-6 rounded-xl max-w-md w-full"
        onClick={(e) => e.stopPropagation()}
      >
        {children}
      </div>
    </div>,
    modalEl.current
  );
};

export default Modal;